import { html, nothing } from 'lit';
import componentStyles from './cta-location-hero.css.lit.ts';
import QueryComponent from '../../base/query-component/QueryComponent.js';
import {classMap} from "lit-html/directives/class-map";

/**
 * Call to Action location card.
 *
 * @element hf-cta-image
 */
export default class CtaLocationHero extends QueryComponent {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      address: { type: String },
      /**
       * Links array of objects.
       * @type {{title: string, bodyText: string, icon: string, url: string}}
       */
      links: { type: Array },
      /**
       * Icon card objects.
       * @type {{type: string, text: string, icon: string, link: string, disabled: boolean}}
       */
      button: { type: Object },
      locationItems: { type: String },
    };
  }

  constructor() {
    super();
    this.locationItems = ''
  }

  render() {
    return html`
      <div
        class="${classMap({
          'cta-location-hero': true,
        })}"
      >
        <div class="cta-location-hero__wrapper">
          <div class="cta-location-hero__content">
            <hf-heading
              level="1"
              levelStyle="heading1"
              class="cta-location-hero__title"
            >
              ${this.title}
            </hf-heading>
            ${this._mediaQuery('md', 'max')
              ? html`
                <div class="cta-location-hero__image--mobile">
                  <hf-responsive-image
                    imageStyle="cta-location-image"
                  >
                    <div slot="image">
                      <slot name="image"></slot>
                    </div>
                  </hf-responsive-image>
                </div>`
              : nothing}
            <hf-wysiwyg class="cta-location-hero__text" markup="${this.address}"></hf-wysiwyg>
            ${this.links.map(link => {
              if (link.url && link.text) {
                return html`<a class="cta-location-hero__link" href="${link.url}">
                  <hf-icon
                    name="${link.icon}"
                    class="cta-location-hero__icon"
                  ></hf-icon>
                  ${link.text}
                </a>`;
              }
            })}
            ${this.button.link ? html`
            <hf-button
              class="cta-location-hero__button"
              href="${this.button.link}"
              target="_self"
              icon="${this.button.icon}"
              iconStyleclass="location-hero"
              type="${this.button.type}--grow"
              disabled="${this.button.disabled}"
              >${this.button.text}</hf-button>` : nothing}
          </div>
          ${this._mediaQuery('md', 'min')
            ? html`
                  <div class="cta-location-hero__image">
                    <hf-responsive-image
                      imageStyle="cta-location-image"
                    >
                      <div slot="image">
                        <slot name="image"></slot>
                      </div>
                    </hf-responsive-image>
                  </div>
              `
            : nothing}
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-location-hero', CtaLocationHero);
